import React from 'react';
import useTranslate from '../../Hooks/useTranslate';
import { Tooltip, IconButton as MUIIconButton } from '@mui/material';

const IconButton = function IconButton({
  id = '',
  title = '',
  onClick = () => {},
  size = 'medium',
  disabled = false,
  children,
  tooltipProps = {},
  iconProps = {},
}) {
  const translate = useTranslate();
  return (
    <Tooltip title={translate(title)} placement="bottom" {...tooltipProps}>
      <MUIIconButton
        id={id}
        onClick={onClick}
        size={size}
        disabled={disabled}
        {...iconProps}
      >
        {children}
      </MUIIconButton>
    </Tooltip>
  );
};

export default IconButton;
